import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import DocumentPreviewPane from "./DocumentPreviewPane";

/**
 * Shared modal preview for any module.
 */
export default function DocumentPreviewModal({
  open,
  onClose,
  sourceModule = "",
  sourceTable = "",
  documentId = "",
  documentUrl = "",
  documentExtension = "",
  documentTitle = "Document",
  documentCode = "",
}) {
  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  const modal = (
    <div
      className="modal fade show d-block qms-doc-preview-modal"
      tabIndex={-1}
      role="dialog"
      aria-modal="true"
      aria-label="Document preview"
      style={{ backgroundColor: "rgba(15, 23, 42, 0.45)", zIndex: 2300 }}
      onClick={onClose}
    >
      <div
        className="modal-dialog qms-doc-preview-modal__dialog"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="modal-content qms-doc-preview-modal__content">
          <div className="modal-header qms-doc-preview-modal__header">
            <div className="qms-doc-preview-modal__title-wrap">
              <h5 className="modal-title mb-0">{documentTitle || "Document"}</h5>
              {documentCode ? (
                <div className="qms-doc-preview-modal__code">{documentCode}</div>
              ) : null}
            </div>
            <button
              type="button"
              className="btn-close"
              aria-label="Close preview"
              onClick={onClose}
            />
          </div>
          <div className="modal-body qms-doc-preview-modal__body">
            <DocumentPreviewPane
              active={open}
              sourceModule={sourceModule}
              sourceTable={sourceTable}
              documentId={documentId}
              documentUrl={documentUrl}
              documentExtension={documentExtension}
              documentTitle={documentTitle}
              showDownloadOriginal
            />
          </div>
        </div>
      </div>
    </div>
  );

  return createPortal(modal, document.body);
}
